import React, { useState, useContext, useEffect } from 'react'
import PatientContext from '../../../context/patientContext'
import UserPrefContext from '../../../context/userPrefContext'
import DictionaryContext from '../../../context/dictionaryContext'
import AuthContext from '../../../context/authContext'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
// import EFaceGroup from './EFaceGroup'      
import ErrorDialogModal from '../modals/ErrorDialogModal'           
import DatePicker from 'react-datepicker'
import moment from 'moment'
import ConfirmDialog from '../shared/ConfirmDialog'
import {BsSignStopFill } from 'react-icons/bs'
import EarQQuestionGroup from './EarQQuestionGroup';



function EarQEditModal(props) {

    const panelName = 'earq_panel'
    const dictCtx = useContext(DictionaryContext)

    const visCtx = useContext(PatientContext)
    const userPrefCtx = useContext(UserPrefContext)
    const authCtx = useContext(AuthContext)
    const eFaceCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/the_efaces/${visCtx.pat_token}`
    const eFaceUpdateURL = (id) => `${process.env.REACT_APP_SERVER}/api/v1/the_efaces/${id}`
    const earQDeleteURL = (id) => `${process.env.REACT_APP_SERVER}/api/v1/form_responses/${id}`
   

    const [groups, setGroups] = useState([])
    const [sortedQuestions, setSortedQuestions] = useState([])
    const [modalTitle, setModalTitle] = useState('')
    const [earQValues, setEarQValues] = useState({})

    // const [startDate, setStartDate] = useState(new Date())
    const [showError, setShowError] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false)
    const [language, setLanguage] = useState("")
    const [errors, setErrors] = useState([])
    const [formId, setFormId] = useState()
    const [surveyDate, setSurveyDate] = useState(new Date())


    let httpHeaders = (token) => {return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'accept': 'application/json',
        auth: authCtx.authMode,
    }}


    const onLanguageChange = (event) => {
      // console.log("Language changed to", event.target.value )
      setLanguage(event.target.value)
    }


    useEffect(() => {
            if (dictCtx.dict_intake_form.length > 0) {
                const intakeForm = dictCtx.dict_intake_form.find(form => {
                    return form.display_name_short === panelName.replace("_panel","")
                })
    
                if (intakeForm !== undefined) {
                    // setIntakeFormId(intakeForm.id)
                    // sort questions by sort_position
                    const questions = dictCtx.dict_intake_form_question.filter(quest => {
                        return quest.DictIntakeFormQuestion.dict_intake_form_id === intakeForm.id && /*quest.DictIntakeFormQuestion.question_option_values !== null &&*/
                          !!quest.DictIntakeFormQuestion.is_active 
    
                    })
    
                    setFormId(intakeForm.id);
                    
                    const comp = (a,b) => {
                        var agrp = (+a.DictIntakeFormQuestion.group_id) * 100 + (+a.DictIntakeFormQuestion.sort_position)
                        var bgrp = (+b.DictIntakeFormQuestion.group_id) * 100 + (+b.DictIntakeFormQuestion.sort_position)
                        return agrp - bgrp
                    }
                    // const sortedQuestions = questions.sort((a,b) => a.sort_position - b.sort_postion)
                    let sortedQs = questions.sort(comp)
                    sortedQs = sortedQs.map(q => {
                      return {
                        id: q.DictIntakeFormQuestion.id,
                        question: q.DictIntakeFormQuestion,
                        is_required: q.DictIntakeFormQuestion.is_required,
                      }
                    })
                    // console.log("Sorted questions", sortedQs)
                    setSortedQuestions(sortedQs)
    
                    if (props.earQOptions.mode === 'ipad' && !!props.patient) {
                        // ipad mode - get user name from props.patient
                        setModalTitle(`${intakeForm.display_name} - ${props.patient.last_name}, ${props.patient.first_name}`)
                    } else {
                        // "normal mode - take patient details from patient context"
                        setModalTitle(`${intakeForm.display_name} - ${visCtx.pat_last}, ${visCtx.pat_first}`)
                    }

                    let fiVals = []
                    if (props.earQOptions.mode === 'editing') {
                        setSurveyDate(moment(props.earQOptions.earQ.visit_date).toDate())

                        fiVals = sortedQs.reduce((accum, element) => {
                            // console.log("accum, element", accum, element)
                            accum[element.question.id] = props.earQOptions.earQ.answers.find(a => a.question_id == element.question.id)?.answer
                            return accum
                        }, {})
                        // setEarQValues(fiVals)
                    } else {
                      if (props.earQOptions.mode === 'new') {
                        fiVals = sortedQs.reduce((accum, element) => {
                            // accum[element.DictIntakeFormQuestion.display_name_short] = 0
                            accum[element.question.id] = 0
                            return accum
                        }, {})
                      }
                    }
                    
    
    
                    // create result object for EarQ like {q0:0, q1:0,...}
                    // we will use this object to post results
                    // fiVals = sortedQs.reduce((accum, element) => {
                    //     // accum[element.DictIntakeFormQuestion.display_name_short] = 0
                    //     accum[element.question.id] = 0
                    //     return accum
                    // }, {})
    
                    // console.log("earQ fiVals", fiVals)
                    setEarQValues(fiVals)
    
    
    
                    // setFormQuestions(sortedQuestions)
    
                    // get group_ids of questions (only one id per group)
                    const groups_c = sortedQs
                        .map((value, index, qs) => (index > 0 && qs[index-1].question.group_id === value.question.group_id) ? null : value.question.group_id)
                        .filter(value => value !== null)
    
                    // console.log("groups",groups_c)
                    setGroups(groups_c)
                }
    
                // ipad mode
                if (!!props.earQOptions?.mode && props.earQOptions.mode === 'ipad') {
                    setShow(true)
                }
            }
        }, [dictCtx.dict_intake_form.length, visCtx, props.earQOptions, props.patient])


    // useEffect(() => {

    //     const dictPanel = dictCtx.dict_panel.find(pnl => pnl.display_name_short === panelName)

    //     if (dictPanel !== undefined) {
    //         const intakeForm = dictCtx.dict_intake_form.find(form => {
    //             return form.display_name_short === dictPanel.display_name_short.replace("_panel","")
    //         })

    //         if (intakeForm !== undefined) {
    //             const questions = dictCtx.dict_intake_form_question.filter(quest => {
    //                 return quest.DictIntakeFormQuestion.dict_intake_form_id === intakeForm.id
    //             })
                
    //             const comp = (a,b) => {
    //                 var agrp = (+a.DictIntakeFormQuestion.group_id) * 100 + (+a.DictIntakeFormQuestion.sort_position)
    //                 var bgrp = (+b.DictIntakeFormQuestion.group_id) * 100 + (+b.DictIntakeFormQuestion.sort_position)
    //                 return agrp - bgrp
    //             }
    //             // const sortedQuestions = questions.sort((a,b) => a.sort_position - b.sort_postion)
    //             const sortedQs = questions.sort(comp)
    //             // console.log("Sorted questions", sortedQs)
    //             setSortedQuestions(sortedQs)

    //             setModalTitle(`${intakeForm.display_name} - ${visCtx.pat_last}, ${visCtx.pat_first}`)

    //             // create result object for e-Face like {{display_name_short}}:{value}},...}
    //             // we will use this object to post results
    //             if (props.mode.mode === 'new') {
    //                 const fiVals = sortedQs.reduce((accum, element) => {
    //                     // set default value as half-way value
    //                     // set default value to 100 (2023-09-21) - requested by the users
    //                     const labVals = JSON.parse(element.DictIntakeFormQuestion.question_option_values)
    //                     // accum[element.DictIntakeFormQuestion.display_name_short] = labVals[labVals.length-1]/2
    //                     accum[element.DictIntakeFormQuestion.display_name_short] = 100
    //                     return accum
    //                 }, {})
    
    //                 setEarQValues(fiVals)
    //             } else {
    //                 // should be editing
    //                 if (props.mode.mode === 'editing') {
    //                     // console.log("EFaceEditModal in editing mode: eface=",props.mode.eface)
    //                     // populate from eface
    //                     // set startDate from eface
    //                     setStartDate(moment(props.mode.earQ.updated_at).toDate())
    //                     const fiVals = sortedQs.reduce((accum, element) => {
    //                         accum[element.DictIntakeFormQuestion.display_name_short] = props.mode.earQ[element.DictIntakeFormQuestion.display_name_short]
    //                         return accum
    //                     }, {})
    //                     setEarQValues(fiVals)
    //                 }
                    
    //             }

    //             // get group_ids of questions (only one id per group)
    //             const groups_c = sortedQs
    //                 .map((value, index, qs) => (index > 0 && qs[index-1].DictIntakeFormQuestion.group_id === value.DictIntakeFormQuestion.group_id) ? null : value.DictIntakeFormQuestion.group_id)
    //                 .filter(value => value !== null)

    //             setGroups(groups_c)
    //         }
    //     }

    // }, [dictCtx.dict_panel.length, props.mode])

     const valueChanged = (question, value) => {
        // console.log("faceInstrumentValues", faceInstrumentValues)
        // console.log("Question value changed! Question:", question, ", Value:", value)
        setEarQValues({...earQValues, [question]:value})
    }


    // validate and save changes
    const handleSave = () => {
        // console.log("earQValues before save", earQValues)

        // make sure we have all values set 
        const keys = Object.keys(earQValues)

        // console.log("earQValues", earQValues)
        // console.log("Errors - sortedQuestions", sortedQuestions)
        const errorsArr = keys.filter((key) => {
            // console.log("Errors - key", key)
            // console.log("Errors - question", sortedQuestions.find(q => q.id == key))
            return earQValues[key] === 0 && !!sortedQuestions.find(q => q.id == key).is_required
        })

        setErrors(errorsArr)

        // console.log("Errors - missing values in questions", errorsArr)

        // if errors array is empty then all fields populated; otherwise some are not
        if (errorsArr.length === 0) {
            // save data
            saveEarQ()

            if (props.earQOptions.mode === 'new' || props.earQOptions.mode === 'editing') {
                // change last updated time
                if (!!props.setLastUpdatedTime) {
                    props.setLastUpdatedTime(new Date().getTime())
                }
                // // call parent onSave - to let parent to refresh the earQ view
                // props.onSaveOrDelete()
                // // setShow(false)
                // props.onClose()
            } else if (props.earQOptions.mode === 'ipad') {
                // ipad mode - log out
                logout()
            }
            
        }        
    }


    const saveEarQ = async() => {
        try {
            // console.log("Creating face instruments", JSON.stringify(faceInstrumentValues))
            let earQCreateURL = ''
            if (props.earQOptions.mode === 'ipad' && !!props.patient) {
                // ipad mode - get patient token from props.patient
                earQCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/earq/from_ipad/${props.patient.form_id}/${props.patient.patient_token}`
            } else {
                // "normal" mode - take patient token from patient context
                if (props.earQOptions.mode === 'new') {
                  earQCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/form_responses/${visCtx.pat_token}`
                } else if (props.earQOptions.mode === 'editing') {
                  earQCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/form_responses/${props.earQOptions.earQ.id}`
                }
                
            }

            // console.log("earQCreateURL", earQCreateURL)

            // remove questions without answer options - they are for headers only
            const filteredQuestions = sortedQuestions.filter(q => q.question.question_option_values !== null)
            // console.log("filteredQuestions", filteredQuestions)
            const groupped = Object.groupBy(filteredQuestions, q => q.question.group_display_name_short)
            // const groupped = Object.groupBy(sortedQuestions, q => q.question.group_display_name_short)
            // console.log("groupped", groupped)

            // const dict_intake_form_id = sortedQuestions[0].question.DictIntakeForm.id;
            const groupVals = Object.keys(groupped).map(gname => {
              const groupAnswers = filteredQuestions.filter(sq => sq.question.group_display_name_short == gname)
              // const groupAnswers = sortedQuestions.filter(sq => sq.question.group_display_name_short == gname)
              // console.log("groupAnswers for group", gname, groupAnswers)

              const vals = groupAnswers.map(ga => { 
                return {[ga.id]: earQValues[ga.id] }
              })

              const theVals = vals.reduce((accum, v, index, arr) => {
                const key = Object.keys(v)[0];
                return {...accum, [key]: v[key]  }
              },{})

              // console.log("theVals", theVals)

              return {
                scale: gname,
                // dict_intake_form_id: dict_intake_form_id,
                dict_intake_form_id:formId,
                // answers: earQValues.filter(eqv => eqv)
                answers: theVals,
                visit_date: surveyDate.toISOString().split('T')[0],
              }
            })

            // console.log("groupVals", groupVals)

            const body = {
              surveys: groupVals
            }

            // console.log("body", body)
            
            const response = await fetch(earQCreateURL, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userPrefCtx.bearerToken}`,
                    'accept': 'application/json',
                    auth: authCtx.authMode,
                },
                method: props.earQOptions.mode === 'new' ? "POST" : "PATCH",
                // body: JSON.stringify(earQValues),
                body: JSON.stringify(body),
            })

            if (response.status === 200 || response.status === 201) {
                const responseData = await response.json()
                // console.log("Created Face Instruments: responseData", responseData)
                // call parent onSave - to let parent to refresh the earQ view
                props.onSaveOrDelete()
                if (!!props.setLastUpdatedTime) {
                    props.setLastUpdatedTime(new Date().getTime())
                }
                // setShow(false)
                props.onClose()


            } else {
                console.log("Failed to create Ear-Q", response)
                if (!response.ok) {
                    throw new Error('Unprocessable Entity: ' + response.statusText);
               }
            }
        } catch (e) {
            console.log("Failed to create Ear-Q", e)
            setShowError(true);
        }

    }


    // const saveEFace = async() => {
    //     try {            
    //         const formattedDate = startDate.toISOString().split('T')[0]
    //         // console.log("Save EFace formatted Date", formattedDate)

    //         const httpMethod = props.mode.eface === null ? "POST" : "PATCH"
    //         const url = props.mode.eface === null ? eFaceCreateURL : eFaceUpdateURL(props.mode.eface.id)

    //         const response = await fetch(url, {
    //             headers: httpHeaders(userPrefCtx.bearerToken),
    //             method: httpMethod,
    //             body: JSON.stringify({...eFaceValues, eface_date:formattedDate}),
    //         })

    //         if (response.status === 200) {
    //             const responseData = await response.json()
    //             // console.log("Created/updated e-Face", responseData)
    //             props.onClose()

    //         } else {
    //             console.log("Failed to create/update e-Face", response)
    //             if (!response.ok) {
    //                 throw new Error('Unprocessable Entity: ' + response.statusText);
    //            }
    //         }
    //     } catch (e) {
    //         console.log("Failed to create/update e-Face", e)
    //         setShowError(true);
    //     }

    // }


    const closeConfirmDialog = (result) => {
        setShowConfirm(false)
        if (result === 'confirm') {
            if (props.earQOptions.earQ !== null && props.earQOptions.earQ.id !==null) {
                deleteEarQ(props.earQOptions.earQ.id)
                // props.onSaveOrDelete()
                props.onClose()
            }

        }
    }

    // const handleSave = () => {
    //     saveEFace()
    //     // call parent onSave - to let parent to refresh the eface view
    //     props.onSaveOrDelete()
    //     //props.onClose()
    // }

    const deleteEarQ = async (earQ_id) => {
        const url = earQDeleteURL(earQ_id)
        try {
            const response = await fetch(url, {
                headers: httpHeaders(userPrefCtx.bearerToken),
                method: "DELETE",
            })

            if (response.status === 200) {
                const responseData = await response.json()
                // console.log("Deleted e-Face", responseData)
                props.onSaveOrDelete()
                if (!!props.setLastUpdatedTime) {
                    props.setLastUpdatedTime(new Date().getTime())
                }
                props.onClose()
            } else {
                console.log("Failed to delete ear-Q", response)
                if (!response.ok) {
                    throw new Error('Unprocessable Entity: ' + response.statusText);
               }
            }
        } catch (e) {
            console.log("Failed to delete ear-Q", e)
            setShowError(true);
        }
    }

    // delete eface
    const handleDelete = () => {
        setShowConfirm(true)

        // if (props.mode.eface !== null && props.mode.eface.id !==null) {
        //     deleteEFace(props.mode.eface.id)
        //     // props.onSaveOrDelete()
        //     props.onClose()
        // }

    }


    return (
        <>
            <ConfirmDialog 
                show={showConfirm}
                title='Please confirm'
                modal_class='delete-confirm-modal'
                title_class='delete-confirm-title'
                footer_class='delete-confirm-title'
                prompt='The earQ will be permamently deleted. Are you sure you want to delete this earQ? '
                prompt_class='diags-modal-delete-confirm-prompt'
                // cancel_button_text='Do not delete!'
                confirm_button_text='Delete'
                confirm_button_variant='danger'
                onClose={(result) => closeConfirmDialog(result)}
                icon={<BsSignStopFill />}
                iconColor='red'
                iconSize='1.3em'
            />
            <ErrorDialogModal
                setOpen={showError}
                close={() => setShowError(false)}
                componentName="EFace"
            />
        <Modal size="fullscreen" show={props.show} onHide={props.onClose} animation={false}
            style={{ visibility: (showError) ? 'hidden' : 'visible' }}
        >
            <Modal.Header closeButton>
                    <Modal.Title>
                      <h4>{modalTitle}</h4>
                      <Form.Check className='language-radio'
                        inline
                        label="English"
                        name="earq_form_language"
                        type="radio"
                        id="earq_form_language_en"
                        value=''
                        onChange={onLanguageChange}
                        defaultChecked
                      />
                      <Form.Check className='language-radio'
                        inline
                        label="Español"
                        name="earq_form_language"
                        type="radio"
                        id="earq_form_language_es"
                        value='_es'
                        onChange={onLanguageChange}
                      />
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <div className='col-12'>
                    <DatePicker selected={surveyDate} onChange={(date) => setSurveyDate(date)} 
                        className="datepicker-w100" 
                    />
                  </div>
                    <div>
                        {groups.map((group_id, index) => 
                            <EarQQuestionGroup 
                                key={index}
                                group_id={group_id}
                                questions={sortedQuestions.filter(q => q.question.group_id === group_id)}
                                values={earQValues}
                                onChange={valueChanged}
                                errors={errors}
                                // language='_es'
                                language={language}
                            />
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer className='justify-content-between'>
                    <div className='w-100'>
                        {errors.length > 0 && <span style={{color:'red', fontWeight:'bold'}} className='text-danger font-weight-bold'>All fields must be populated!</span>}
                    </div>
                    
                    <div className="inline-block text-left">
                        <Button className='mx-2' variant="secondary" onClick={props.onClose}>
                            {props.earQOptions.mode === 'ipad' ? 'Logout' : 'Close'}
                        </Button>
                        {props.earQOptions.earQ !== null &&
                          <Button className='mx-2 danger-button' variant="primary" onClick={handleDelete}>
                              Delete
                          </Button>
                        }
                    </div>
                    <div className='inline-block text-right'>
                        <Button className='mx-2' variant="primary" onClick={handleSave}>
                            Save Changes
                        </Button>
                    </div>
                    
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default EarQEditModal
